import React, { useEffect, useState  } from 'react';
import Swal from "sweetalert2";
import ConnectAPI from '../../services/api';
import { Button, Select,TextBox,TreeView,List,ListItem, IconPrinter } from "@veneer/core";
import { Col, Row } from "react-bootstrap";

function Generalconsumables( { consumabledetail,onsuccessgeneral }) {
    const connectApi = new ConnectAPI();
    const [idpart, setidpart]=useState("");
    const [description, setdescription]=useState("");
    const [units, setunits]=useState(0);
    const [transferBrasil,settransferBrasil]=useState(0);
    const [transferMca,settransferMca]=useState(0);
    const [transfermexico,settransfermexico]=useState(0);
    const [consumableselect,setconsumableselect]=useState([]);
    const [idConsumableType,setidConsumableType]=useState();
    const [presses,setpresses]=useState([]);
    const [nodeitem,setnodeitem]=useState([]);
    const [listcomp, setlistcomp]=useState([]);

    useEffect(()=>{
        gettypeconsumable();
        if(consumabledetail===null){
            setidpart("");
            setdescription("");
            setunits("");
            settransferBrasil("");
            settransferMca("");
            settransfermexico("");
            setidConsumableType("");
            setfamily();
        }else{
            setidpart(consumabledetail.idPart);
            setdescription(consumabledetail.description);
            setunits(consumabledetail.units);
            settransferBrasil(consumabledetail.transferPriceBrasil);
            settransferMca(consumabledetail.transferPriceMCA);
            settransfermexico(consumabledetail.transferPriceMexico);
            setidConsumableType(consumabledetail.idConsumableType.toString());
        }
    },[consumabledetail]);
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    function setfamily(){
        connectApi
            .get("api/Channels/getpressfamily","",consolidfamily)
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            });
    }
    function gettypeconsumable(){
        connectApi
            .get("api/Channels/getconsumabletype","",consolid)
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    "Error " + error?.response?.status,
                    error?.response?.data,
                    "error"
                );
            });
    }
    const consolidfamily=(status, data)=>{
        setpresses(data);
        var filterfamily=data.map(item=>item.family).filter(onlyUnique);
        var groupfilter=data.map(item=>item.group).filter(onlyUnique);


        var items=[
          {
            id: 'Group',
            label: 'Group',
            icon: <IconPrinter />,
            nodes:[]
          }];
        
        groupfilter.filter(el=>el!="").map((item)=>{
            var onenode=[];
            var res;
            data.map((i)=>{
                if(i.group===item && i.family!=""){
                    res=onenode.some(alfa => i.family === alfa.label);
                    if(res==false){
                        onenode.push({
                            id: i.family,
                            label: i.family,
                            icon: <IconPrinter />,
                            nodes:[]
                          });
                    }
                }
            })
            items[0].nodes.push({
                id: item,
                label: item,
                icon: <IconPrinter />,
                nodes:onenode
              });
        });
        var restof=[];
        var restofdata=data.filter(el=>el.group=="" || el.family==""); 
        
        restofdata.map((i)=>{
            restof.push({
                id: i.classification,
                label: i.classification,
                icon: <IconPrinter />,
                nodes:[]
              });
        })
        items[0].nodes.push({
            id: "unclassified",
            label: "unclassified",
            icon: <IconPrinter />,
            nodes:restof
        });
        setnodeitem(items);
    }
    const consolid = (status, data)=>{
        var select=data.map((item)=>{
            return{
                value: item.idConsumableType,
                label: item.type,
            };
        });
        setconsumableselect(select);
    }
    const submitconsumable=()=>{
        let data= new FormData();
        data.append("idpart",idpart.trim());
        data.append("description",description.trim());
        data.append("units",units);
        data.append("idConsumableType",idConsumableType);
        data.append("transferMca",transferMca);
        data.append("transferBrasil",transferBrasil);
        data.append("transfermexico",transfermexico);
        data.append("compat",listcomp);
        if(consumabledetail===null){
            data.append("type","add");
        }else{
            data.append("type","modify");
        }
        connectApi.post("api/channels/saveconsumable",data,consolidgeneral).catch((error) => {
            Swal.fire(
                'Error ' ,
                error,
                'error'
                );
        })
    }
    const consolidgeneral=(status,data)=>{
        onsuccessgeneral(idpart);
    }
    const handleSelect = (name) => (event) => {
        setidConsumableType(event.value);
    };
    const handleClear = (name) => (event) => {
        setidConsumableType();
    };
    const handleSelectedItemsChange = (e, id) => {
        var classifications=[];
        id.map((i)=>{
            if (i=="Group"){
            }else{
                presses.filter((element)=>element.family==i | element.group==i).map((item)=>{
                    classifications.push(item.classification);
                });
            }
        });
        classifications=classifications.map(item=>item).filter(onlyUnique);
        setlistcomp(classifications)
        
    };
   
    return(<>
        <Row>
            <Col>
                <TextBox id="text-box-uncontrolled" label="idpart" value={idpart} onChange={(value) => {setidpart(value);}}/>
            </Col>
            <Col>
                <TextBox id="text-box-uncontrolled" label="Description" value={description} onChange={(value) => {setdescription(value);}}/>
            </Col>
        </Row>
        <Row>
            <Col>
                <TextBox id="text-box-uncontrolled" label="Units (MPS)" value={units} onChange={(value) => {setunits(value);}}/>
            </Col>
            <Col>
                <Select
                    options={consumableselect}
                    id="idconsumabletype"
                    label="Consumable Type"
                    value={[idConsumableType]}
                    onChange={handleSelect()}
                    onClear={handleClear()}
                />
            </Col>
        </Row>
        <Row>
            <Col>
                <TextBox id="text-box-uncontrolled" label="transferMca" value={transferMca} onChange={(value) => {settransferMca(value);}}/>
            </Col>
            <Col>
                <TextBox id="text-box-uncontrolled" label="transferBrasil" value={transferBrasil} onChange={(value) => {settransferBrasil(value);}}/>
            </Col>
            <Col>
                <TextBox id="text-box-uncontrolled" label="transfermexico" value={transfermexico} onChange={(value) => {settransfermexico(value);}}/>
            </Col>
        </Row>
        {(consumabledetail===null )?(<>
            <Row>
                <Col>
                    <TreeView
                        nodes={nodeitem}
                        nodeSelector="multiSelection"
                        onChange={handleSelectedItemsChange}
                    />
                </Col>
                <Col>
                    Items results
                    <List css={{padding: '20px', height: '200px', overflowY: 'auto'}}>
                        {listcomp.map((i)=>{
                            return(
                                <>
                            <ListItem 
                                centerArea={<div>{i}</div>}
                            />
                            </>
                            )
                            
                        })}
                       
                    
                    </List>
                </Col>
            </Row>
            
        </>):(<></>)}
        <br/>
        <Button onClick={submitconsumable}>
            Save
        </Button>
    </>
    );
}
export default Generalconsumables;